import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { isNil } from "lodash-es";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../components/shared/buttons/button-with-loading";
import { View } from "../../../models/TrendingModels";
import { deleteView } from "../../../repository/TrendingRepository";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	view: View | null;
}

export const DeleteViewModal = ({ open, handleClose, view }: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const handleSubmit = async () => {
		setIsLoading(true);
		if (!isNil(view)) {
			const resp = await deleteView(view.ViewId);
			if (!resp.ok) {
				setError(resp.message);
			} else {
				handleClose(true);
			}
		}

		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"xl"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Delete View"
			>
				<Divider />

				<MesfModal.Content>
					{!isNil(view) ? (
						<Grid container spacing={5} style={{ padding: "2rem" }}>
							<Grid
								item
								md={12}
								xs={12}
								style={{ padding: "10px", width: "100%" }}
							>
								<Typography>
									Are yu sure you want to delete{" "}
									<strong>{view?.ViewName}</strong> ?
								</Typography>
							</Grid>
						</Grid>
					) : (
						<Typography>ERROR: No view detected, please select one</Typography>
					)}
				</MesfModal.Content>
				<Divider />
				<MesfModal.Actions>
					<Grid
						container
						spacing={1}
						style={{
							display: "flex",
							alignItems: "flex-end",
							justifyContent: "flex-end",
						}}
					>
						<Grid item>
							<Button
								variant="outlined"
								color="secondary"
								onClick={() => handleClose(false)}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item>
							{!isNil(view) ? (
								<ButtonWithLoading
									variant={"contained"}
									color="secondary"
									onClick={handleSubmit}
									isLoading={isLoading}
								>
									Delete
								</ButtonWithLoading>
							) : (
								<Button
									variant={"contained"}
									style={{ marginRight: "1rem" }}
									color="primary"
									onClick={() => handleClose(false)}
								>
									Ok
								</Button>
							)}
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
